import {ChangePasswordForm} from "../forms/ChangePasswordForm.tsx";
import {useEffect} from "react";
import {useWindowScroll} from "@mantine/hooks";
import {
    IndexPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {Container} from "@mantine/core";

export const ChangePage = () => {
    const [, scrollTo] = useWindowScroll();

    useEffect(() => {
        scrollTo({y: 0})
    }, [scrollTo]);

    return (
        <IndexPageLayout title={'Change Password'} tools={[]}>
            <SimplePageContentWrapper>
                <Container>
                    <ChangePasswordForm/>
                </Container>
            </SimplePageContentWrapper>
        </IndexPageLayout>
    );
};
